/**
 * Phase 8.1 — Centralised z-index hierarchy.
 *
 * Use these constants instead of magic numbers in className strings or inline
 * styles. Order is bottom-to-top:
 *
 *   Map overlays  ─ underlay layers above the basemap (radius, hydrants)
 *   Floating UI   ─ TopBar, InfoCard, SpeedControl, FAB, MapToolbar
 *   Slide panels  ─ MainPanel, DetailPanel
 *   Modals        ─ Settings, Workshop, ConfirmDialog, LevelUp, etc.
 *   Toasts        ─ above modals so errors stay visible
 *   Onboarding    ─ first-run overlay, blocks everything else
 *
 * Tailwind reads these via `style={{ zIndex: Z_X }}` on the root element of
 * each component, OR via `className="z-[20]"` if convenient — keep one source
 * of truth in this file so future jiggling is one-stop.
 */

export const Z_MAP_OVERLAYS = 20;
export const Z_FLOATING = 30;
export const Z_FAB = 30;
export const Z_PANELS = 40;
export const Z_MODALS = 90;
export const Z_TOASTS = 95;
export const Z_DIALOGS_HIGH = 100;
export const Z_ONBOARDING = 120;
